module.exports = __webpack_public_path__ + "img/ddb8ef5.jpeg";